import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DtoBase } from '@models/base/dtoBase.model';
import { FilterBase } from '@models/base/filterBase.model';
import { EstadoEscritoService } from '@services/estadoEscrito/estadoEscrito.service';
import { TipoEscritoService } from '@services/tipoEscrito/tipoEscrito.service';
import { NgxSpinnerModule } from 'ngx-spinner';

export interface FiltrosDialogData {
  showEscritos: boolean;
  showPlantillas: boolean;
}

@Component({
  selector: 'app-filtros-dialog',
  standalone: true,
  imports: [CommonModule,MatIconModule,MatButtonModule,NgxSpinnerModule,MatFormFieldModule,ReactiveFormsModule,MatProgressSpinnerModule,MatMenuModule,MatDividerModule,MatDialogModule,MatCheckboxModule,MatInputModule,MatDatepickerModule,MatNativeDateModule,],
  templateUrl: './filtros-dialog.component.html',
  styleUrl: './filtros-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltrosDialogComponent extends FilterBase{

  filtrosForm: FormGroup;
  tiposEscrito: DtoBase[] = [];
  estadosEscrito: DtoBase[] = [];
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private tipoEscritoService: TipoEscritoService,
    private estadoEscritoService: EstadoEscritoService,
    private dialogRef: MatDialogRef<FiltrosDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FiltrosDialogData
  ) {
    super()
    this.filtrosForm = this.fb.group({
      showEscritos: [data.showEscritos || true],
      showPlantillas: [data.showPlantillas || true],
      tiposEscrito: [[]],
      estadosEscrito: [[]],
      fechaDesde: [null],
      fechaHasta: [null],
      creadoPor: ['']
    });
  }

  ngOnInit(): void {
    this.loadCatalogos();
  }

  private loadCatalogos(): void {
    this.isLoading = true;

    Promise.all([
      this.tipoEscritoService.getAll().toPromise(),
      this.estadoEscritoService.getAll().toPromise()
    ]).then(([tipos, estados]) => {
      this.tiposEscrito = tipos || [];
      this.estadosEscrito = estados || [];
      this.isLoading = false;
    }).catch(error => {
      console.error('Error cargando catálogos:', error);
      this.isLoading = false;
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    if (this.filtrosForm.valid) {
      const filtros = this.filtrosForm.value;
      this.dialogRef.close(filtros);
    }
  }

  onReset(): void {
    this.filtrosForm.reset({
      showEscritos: true,
      showPlantillas: true,
      tiposEscrito: [],
      estadosEscrito: [],
      fechaDesde: null,
      fechaHasta: null,
      creadoPor: ''
    });
  }

  toggleAll(controlName: string, items: any[]): void {
    const control = this.filtrosForm.get(controlName);
    const currentValue = control?.value || [];

    if (currentValue.length === items.length) {
      // Si todos están seleccionados, deseleccionar todos
      control?.setValue([]);
    } else {
      // Si no todos están seleccionados, seleccionar todos
      control?.setValue(items.map(item => item.id));
    }
  }

  isAllSelected(controlName: string, items: any[]): boolean {
    const control = this.filtrosForm.get(controlName);
    const currentValue = control?.value || [];
    return currentValue.length === items.length;
  }

  isIndeterminate(controlName: string, items: any[]): boolean {
    const control = this.filtrosForm.get(controlName);
    const currentValue = control?.value || [];
    return currentValue.length > 0 && currentValue.length < items.length;
  }
}

